export default __webpack_public_path__ + "static/media/evo-img.3b0da173.webp";